import * as React from 'react';
import update from 'immutability-helper';
import { Segment, Button } from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { getCleanDateFromTicks } from 'helpers/date-helper';
import { translations } from 'types/translations';
import { AuditLog } from 'types/audit-log';
import * as logger from 'logger';

import './styles.css';
import { LogLevel } from 'types/log-level';

const LINES_SHOWN = 10;

export interface Props {
  auditLogs: AuditLog[];
}

interface State {
  isConsoleOpen: boolean;
}

export class AuditLogs extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      isConsoleOpen: false
    };
  }

  public render() {
    const i18n = getI18n();
    let linesToShow = this.state.isConsoleOpen ? LINES_SHOWN : 0;

    let buttonClassName = 'audit-logs-preview-button';

    if (this.state.isConsoleOpen) {
      buttonClassName += ' button-box-shadow';
    }

    return (
      <Segment clearing={true} className="audit-logs no-margin-bottom">
        <Button icon={this.state.isConsoleOpen ? 'angle down' : 'angle up'} className={buttonClassName}
          onClick={this.handleConsoleToggle} />
        {this.state.isConsoleOpen &&
          <div className="no-margin-bottom content">
            {
              this.props.auditLogs.length !== 0
                ?
                this.props.auditLogs.slice(0, linesToShow).map((auditLog: AuditLog) => {
                  return (
                    <p className="audit-log" key={auditLog.id.toString()}>
                      {`${getCleanDateFromTicks(auditLog.timestamp)} | ${auditLog.message}`}
                    </p>
                  );
                })
                : linesToShow > 0
                  ? <p>{i18n.t(translations.NothingToShow)}</p>
                  : null
            }
          </div>
        }
      </Segment>
    );
  }

  handleConsoleToggle = () => {
    if (!this.state.isConsoleOpen) {
      logger.log(LogLevel.INFO, 'Audit log console window was opened', 'AuditLogComponent', 'Audit Console Opened');
    }
    this.setState(update(this.state, {
      isConsoleOpen: { $set: !this.state.isConsoleOpen }
    }));
  }
}


// WEBPACK FOOTER //
// ./src/components/audit-logs/component.tsx